var map = {
	"./bg.json": "dcd0",
	"./cs.json": "c686",
	"./de.json": "6ce2",
	"./el.json": "f184",
	"./en.json": "edd4",
	"./en_AU.json": "a725",
	"./en_CA.json": "2631",
	"./en_NZ.json": "a14a",
	"./en_ZA.json": "5030",
	"./es_ES.json": "9152",
	"./et.json": "e1db",
	"./fi.json": "5754",
	"./fr.json": "f693",
	"./fr_CA.json": "1a7f",
	"./hu.json": "4e73",
	"./it.json": "0825",
	"./no.json": "f947",
	"./pl.json": "89b2",
	"./pt.json": "5d67",
	"./pt_BR.json": "0c31",
	"./ro.json": "9542",
	"./sk.json": "3da9",
	"./sl.json": "d34a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";